import { UseFormReturn } from 'react-hook-form'
import { useEffect } from 'react'
import { useToggle } from 'react-use'
import { useLazyGetRiskMapsCustomValuesQuery } from '@services/riskMaps'
import { Option } from '@organisms/Select'
import {
  getDangerHazardName,
  getEventName,
  getHardGradeName,
  getProbabilityName,
} from '@modals/RiskMapModal/Dangers/nameUtils'
import SeverityDegrees from '@enums/SeverityDegrees'
import InjuryPossibilities from '@enums/InjuryPossibilities'
import SEVERITY_DEGREES from '@const/severityDegrees'
import INJURY_POSSIBILITIES from '@const/injuryPossibilities'
import { DEFAULT_HARD_AND_PROBABILITY } from '@modals/RiskMapModal/getDefaultValues'

const useAutoPrefillHardGradeAndPossibility = (
  { watch, setValue }: UseFormReturn,
  index: number
) => {
  const [valuesIsPrefilled, toggleValuesIsPrefilled] = useToggle(false)

  const dangersControlMeasureWorkplace: 'office' | null = watch(
    'dangersControlMeasureWorkplace'
  )?.value
  const hazard: Option | undefined = watch(getDangerHazardName(index))
  const event: Option | undefined = watch(getEventName(index))
  const hardGrade: Option<SeverityDegrees> | undefined = watch(
    getHardGradeName(index)
  )
  const probability: Option<InjuryPossibilities> | undefined = watch(
    getProbabilityName(index)
  )

  const [getCustomValues, { data }] = useLazyGetRiskMapsCustomValuesQuery()

  useEffect(() => {
    if (data) {
      const customValue = data.items.find(
        (el) => dangersControlMeasureWorkplace === el.workplace
      )

      setValue(
        getHardGradeName(index),
        customValue
          ? SEVERITY_DEGREES.find(
              (degree) => degree.value === customValue.injurySeverity
            )
          : DEFAULT_HARD_AND_PROBABILITY.hardGrade
      )
      setValue(
        getProbabilityName(index),
        customValue
          ? INJURY_POSSIBILITIES.find(
              (possibility) =>
                possibility.value === customValue.injuryPossibility
            )
          : DEFAULT_HARD_AND_PROBABILITY.probability
      )

      toggleValuesIsPrefilled(true)
    }
  }, [
    dangersControlMeasureWorkplace,
    data,
    index,
    setValue,
    toggleValuesIsPrefilled,
  ])

  useEffect(() => {
    if (hardGrade || probability || valuesIsPrefilled) return

    if (hazard && event) {
      getCustomValues({
        hazard: hazard.value,
        event: event.value,
      })
    }
  }, [
    event,
    getCustomValues,
    hardGrade,
    hazard,
    probability,
    valuesIsPrefilled,
  ])
}

export default useAutoPrefillHardGradeAndPossibility
